export class HistoryDialogDTO{
	protocolStepName: string;
	scans: Array<any> = [];
    scannedPlateID:string;
	dialogName: string;
	componentPopupTitle: string;
	isRedoFromHistory: boolean;
	availableRedoList: Array<string> = [];
}
